/* tslint:disable */
export var StoreType;
(function (StoreType) {
    StoreType[StoreType["ITUNES"] = 1] = "ITUNES";
    StoreType[StoreType["GOOGLEPLAY"] = 2] = "GOOGLEPLAY";
    StoreType[StoreType["AMAZON"] = 3] = "AMAZON";
    StoreType[StoreType["WILDTANGENT"] = 4] = "WILDTANGENT";
    StoreType[StoreType["QH360"] = 5] = "QH360";
    StoreType[StoreType["FACEBOOK"] = 6] = "FACEBOOK";
    StoreType[StoreType["SAMSUNG"] = 7] = "SAMSUNG";
    StoreType[StoreType["FACEBOOK_ARCADE"] = 8] = "FACEBOOK_ARCADE";
    StoreType[StoreType["WEB"] = 9] = "WEB";
})(StoreType || (StoreType = {}));
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/StoreTypeEnum.ts
// module id = 1693
// module chunks = 3